/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { AreaJoker } from "./modelAreaJoker";

class ControllerAreaJoker extends ControllerModel {
  constructor(areaJokerName) {
    super("ControllerAreaJoker");
    
    this.setNewNode = (callback, callback2) => {
      let areaJoker = new AreaJoker(areaJokerName);
      areaJoker.decorate(callback, callback2);

      this.addNode(areaJoker);
      SingletonFlowchart.SaveStatus()
    }

    this.loadNode = async (node, callback, callback2) => {
      let areaJoker = new AreaJoker(areaJokerName);
      areaJoker.copyFrom(node);
      await areaJoker.decorate(callback, callback2);
      this.addNode(areaJoker)
    }

    this.getProperties = async (node) => {
      let n = new AreaJoker(areaJokerName);
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new AreaJoker(areaJokerName);
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerAreaJoker };
